import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { InventarioService } from '../inventario.service';
import { Estoque, Inventario } from '../models/inventario';

@Component({
  selector: 'app-inventario-list',
  templateUrl: './inventario-list.component.html',
  styleUrls: ['./inventario-list.component.scss']
})
export class InventarioListComponent implements OnInit {

  constructor(private inventarioService: InventarioService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private translateService: TranslateService) { 

      translateService.setDefaultLang('pt');
  
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translateService.use('pt');
    }

    public pt = {
      firstDayOfWeek: 0,
      dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho','Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      today: 'Hoje',
      clear: 'Limpar'
    };

    inventarios: Inventario[];
    public idInventario: number;
    public inventario: Inventario ={} as Inventario;

    public estoques: Estoque[];
    public estoque: Estoque;
    public data : any;
    
    public submitted: boolean;
    public displayMsg: boolean = false;
    public displayDialog: boolean;

    public minDate: Date = new Date();

  ngOnInit(): void {
    this.getInventarios();
    this.getEstoque();
    
  }


  setEstoque(estoque: Estoque)
  {
    this.inventario.idEstoque = estoque.idEstoque;   
    this.inventario.unidadeEstoque = estoque.cdEstoque;  
  }

  getInventarios() {
    this.inventarioService.getInventarios().subscribe(
      (res) => {
        if (res) {
          this.inventarios = res;  
          console.log(this.inventarios);
        }
      },
      err => {
        console.log("Inventarios");
        console.log(err);
      }
    );
  } 



  addInventario() {
    this.inventario = {} as Inventario;
    this.submitted = false;
    this.displayDialog = true;
    this.estoque = null;
  } 
  
  updInventario(inventario: Inventario) {      
    this.inventario = {...inventario};
    this.data = inventario.dtInventario;
    this.inventario.dtInventario = new Date(inventario.dtInventario);
    this.estoque = this.estoques.find(x => x.idEstoque == inventario.idEstoque);
    console.log(this.inventario)
    this.displayDialog = true;
  }
  
  delInventario(inventario: Inventario) {
      this.confirmationService.confirm({
          message: 'Você tem certeza que deseja remover o inventário: ' + inventario.dsInventario + '?',
          header: 'Confirmação',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
              this.inventarioService
              .delInventario(inventario.idInventario)
              .subscribe(                     
                  () => {this.getInventarios()
                    this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Inventário removido com sucesso!', life: 3000});
                  },
                  err =>{
                    this.messageService.add({severity: 'error', summary: 'Erro!', detail: 'Inventário não pode ser removido, provavelmente existem etapas vinculadas!', life: 3000});
                  
                    console.log(err)
                  } 
              );
              
          }
      });
  }
  
  hideDialog() {
    this.inventario = {} as Inventario;
    this.submitted = false;
    this.displayDialog = false;        
  }
  





  saveInventario(){
    this.submitted = true;      
    if (this.inventario.dsInventario.trim()) {
        if (this.inventario.idInventario) {
          
          this.inventarioService
          .updInventario(this.inventario)
          .subscribe(                     
              () => {
                this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Inventário atualizado com sucesso!', life: 3000});
                this.getInventarios()
              },
              err => console.log(err)
          );
           
        } else {
           this.inventarioService
               .addInventario(this.inventario)
               .subscribe(                     
                   () =>{
                    this.getInventarios()
                    this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Inventário criado com sucesso!', life: 3000});
                   }, 
                   err => 
                   {
                      this.messageService.add({severity: 'warning', summary: 'Erro', detail: 'Ocorreu um erro ao salvar as alterações!', life: 3000});
                     console.log(err)
                   }
               );

            
        }

        this.inventarios = [...this.inventarios];
        this.displayDialog = false;
        this.inventario = {} as Inventario;
    }
  }


  getEstoque(){
    this.inventarioService.getEstoques().subscribe(
        (res) => {
            if (res) {            
              this.estoques = res;                
            }
        },
        err => {
            console.log("Estoques - Inventario");
            console.log(err);        
        }
    );
  }

}
